import { MODAL_SIZE_SM, ModalConfirm } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

export const ModalDelete = ({
  show,
  handleCancel,
  handleConfirm,
  taskName
}) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage(
        {
          id: 'Load.TriggersList.ModalDeleteConfirmTitleNew'
        },
        {
          name: taskName
        }
      )}
      message={intl.formatMessage({
        id: 'Load.TriggersList.ModalDeleteConfirmDescrNew'
      })}
      size={MODAL_SIZE_SM}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant='delete'
    />
  )
}

ModalDelete.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  taskName: PropTypes.string
}
